import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';
import { ChartLine } from '@phosphor-icons/react';

// Logo component
const FinanciALLogo = () => (
  <div className="w-16 h-16 rounded-2xl overflow-hidden bg-white">
    <img 
      src="https://customer-assets-0z36b82j.emergentagent.net/job_1ce9899f-22e9-4951-9d4b-a91c40afd391/artifacts/ktwxigwh_Liquid%20Glass%20Logo.png.png" 
      alt="FinanciAL" 
      className="w-full h-full object-cover"
    />
  </div>
);

const AuthCallback = () => {
  const navigate = useNavigate();
  const { processOAuthSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        console.log('OAuth Callback - Full URL:', window.location.href);
        console.log('OAuth Callback - Hash:', hash);
        
        const params = new URLSearchParams(hash.replace('#', ''));
        const sessionId = params.get('session_id');
        console.log('OAuth Callback - Session ID:', sessionId);

        if (!sessionId) {
          console.error('OAuth Callback - No session_id found in URL');
          toast.error('Autentifikimi dështoi: Nuk ka ID sesioni');
          navigate('/login');
          return;
        }

        // Process the session
        console.log('OAuth Callback - Processing session...');
        await processOAuthSession(sessionId);
        toast.success('Mirë se erdhët në FinanciAL!');
        
        // Clear the hash and navigate
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/dashboard', { replace: true });
      } catch (error) {
        console.error('Auth callback error:', error);
        console.error('Error details:', error.response?.data || error.message);
        toast.error('Autentifikimi dështoi. Ju lutem provoni përsëri.');
        navigate('/login');
      }
    };

    processAuth();
  }, [navigate, processOAuthSession]);

  return (
    <div className="min-h-screen bg-[#F4F4F0] flex items-center justify-center">
      <div className="text-center">
        <div className="mx-auto mb-4 animate-pulse">
          <FinanciALLogo />
        </div>
        <p className="text-[#1A3C34]/70">Duke përfunduar hyrjen...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
